export default "/images/slickslide-1.jpg?fd457e28af5a4a39ab9a66139ea4a800";